/**
 * Landing path for the user's main dashboard after login or "go to dashboard" actions.
 * Admin → /admin only; business → /dashboard; freelancer → /freelancers-tab.
 */
export function getHomeDashboardPath(user) {
  const t = String(user?.user_type || "").toLowerCase();
  if (t === "admin") return "/admin";
  if (t === "business") return "/dashboard";
  if (t === "freelancers" || t === "freelancer") return "/freelancers-tab";
  return "/dashboard";
}
